import * as yup from 'yup'
import { PersonalDetailsType } from '../components/ApplicationForm/ApplicationFormContext'
import { mobileNumberRegex } from '../constants'

interface Validator {
  getValidator: (isInLoqateExperiment?: boolean) => yup.AnySchema
  validateState: (state: PersonalDetailsType) => boolean
}

export const checkIsValidPhoneNumber = (phoneNumber?: string | string[]) => {
  if (!phoneNumber) return false
  const phoneNumberToCheck = Array.isArray(phoneNumber) ? phoneNumber[0] : phoneNumber
  return mobileNumberRegex.test(phoneNumberToCheck)
}

const MobileNumberValidator = (): Validator => {
  const schema = yup.object().shape({
    contactNumber: yup.string()
      .matches(mobileNumberRegex, {
        message: 'Please enter a valid mobile number',
        excludeEmptyString: true
      })
      .typeError('Please enter a valid mobile number')
      .required('Please enter your mobile number')
  })

  return {
    getValidator: () => schema as yup.BaseSchema,
    validateState: (personalDetails: PersonalDetailsType) => schema.isValidSync({
      contactNumber: personalDetails.contactNumber
    })
  }
}

export default MobileNumberValidator
